// import { configureStore } from "@reduxjs/toolkit";
// import dashboardSlice from "./DashBoard/dashboardSlice";
// import authSlice from "./auth.slice";

// export const store = configureStore({
//     reducer: {
//         dashboard: dashboardSlice,
//         auth: authSlice
//     }
// })

import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // uses localStorage for web
import dashboardSlice from "./DashBoard/dashboardSlice";
import authSlice from "./auth.slice";

// Combine your reducers
const rootReducer = combineReducers({
  dashboard: dashboardSlice,
  auth: authSlice,
});

// Configure redux-persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["dashboard"], // only persist the dashboard slice; add auth if needed
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create your store with the persisted reducer and adjusted middleware
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Ignore these redux-persist action types in the serializableCheck middleware
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/FLUSH",
          "persist/PAUSE",
          "persist/PURGE",
          "persist/REGISTER",
        ],
      },
    }),
});

// Create a persistor linked to the store
export const persistor = persistStore(store);
